import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useState } from 'react';

import { PartialSupplier } from '../../../../common/components/autocomplete-list/supplier-autocomplete-list/pool-supplier-autocomplete-list';
import { PoolExternalCustomerMappingSupplierAutocompleteList } from './pool-external-customer-mapping-supplier-autocomplete-list';
import { Supplier } from '../../../../common/models/supplier';

export interface ExternalCustomerMappingFooterProps {
    id: string;
    isCustomer: boolean;
    onAddMapping: (supplier: Supplier) => void;
}

export const ExternalCustomerMappingAddEntry = (props: ExternalCustomerMappingFooterProps) => {
    const [supplier, setSupplier] = useState<PartialSupplier | undefined>(undefined);

    const handleSupplierSelected = (supplier: Supplier | null) => {
        if (supplier) {
            props.onAddMapping(supplier);
        }
        setSupplier(undefined);
    };

    return (
        <Box sx={{ width: '50%' }}>
            <PoolExternalCustomerMappingSupplierAutocompleteList
                onSelected={handleSupplierSelected}
                label={
                    props.isCustomer ? (
                        <FormattedMessage id="app.dashboard.new.contact.customer" />
                    ) : (
                        <FormattedMessage id="app.customer.supplierSearch" />
                    )
                }
                required={false}
                disablePreventOverflow={true}
                value={supplier}
                isCustomer={props.isCustomer}
                accountId={props.id}
            />
        </Box>
    );
};
